<div class="app-menu" (mousemove)="onMouseMove($event)" (mouseleave)="clearHovered()">

  @for (column of columns(); track $index; let colIndex = $index) {
    <div [class]="colClass(colIndex)">

      @if (colIndex === 0) {
        <button class="app-menu__close" (click)="close.emit()" aria-label="Close menu">
          <i class="rc-icon-times fs-24"></i>
        </button>
      }

      <ul class="app-menu__list">
        @for (item of column; track item.link ?? item.id) {
          <li
            class="app-menu__item"
            [class.app-menu__item--active]="isActive(item)"
            [class.app-menu__item--hovered]="hoveredPath()[colIndex] === item"
            [rcNavigate]="item.link"
            (mouseenter)="setHovered(item, colIndex)"
            (click)="onItemClick(item)"
          >
            @if (item.iconClass) {
              <i class="app-menu__item-icon" [class]="item.iconClass"></i>
            }
            <span class="app-menu__item-label">{{ item.label | translate | capitalize }}</span>
            @if (item.children?.length) {
              <i class="app-menu__item-chevron rc-icon-chevron-right"></i>
            }
          </li>
        }
      </ul>
    </div>
  }

</div>